<template>
  <section class="dp-layout enrollment-page">
    <aside class="dp-left filter-card">
      <div class="filter-head">
        <i class="el-icon-s-operation"></i>
        <span>异动离校类型</span>
      </div>
      <nav class="filter-nav" aria-label="异动离校类型">
        <button
          v-for="item in statusItems"
          :key="item.value"
          type="button"
          class="filter-item"
          :class="{ 'is-active': statusFilter === item.value, 'is-child': item.value !== '' }"
          @click="onStatusSelect(item.value)"
        >
          <span class="filter-item__dot" :class="'tone-' + item.tone"></span>
          <span class="filter-item__label">{{ item.label }}</span>
          <i class="el-icon-arrow-right filter-item__arrow"></i>
        </button>
      </nav>
    </aside>

    <section class="dp-right">
      <header class="page-toolbar">
        <div class="page-toolbar__title">
          <h2>{{ viewTitle }}</h2>
          <p>跟顶部学校切换；休学仍在主表，转学/退学已归档。</p>
        </div>
        <div class="enrollment-toolbar">
          <div class="toolbar-filter-bar toolbar-filter-bar--embed enrollment-toolbar__query">
            <el-form :inline="true" class="toolbar-filter-form">
              <div class="toolbar-filter-fields">
                <el-form-item>
                  <el-input
                    v-model="sourceClassName"
                    placeholder="原班级"
                    clearable
                    prefix-icon="el-icon-office-building"
                    class="toolbar-field-w-md"
                    @keyup.enter.native="loadList(1)"
                  />
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="keyword"
                    placeholder="姓名 / 学号 / 卡号"
                    clearable
                    prefix-icon="el-icon-search"
                    class="toolbar-field-w-lg"
                    @keyup.enter.native="loadList(1)"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="small" icon="el-icon-search" @click="loadList(1)">查询</el-button>
                </el-form-item>
              </div>
              <div class="toolbar-filter-actions">
                <el-button size="small" type="info" icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
                <el-button size="small" type="warning" plain icon="el-icon-s-operation" @click="batchDialogVisible = true">
                  批量异动
                </el-button>
              </div>
            </el-form>
          </div>
          <div v-if="isDingTalkSchool" class="enrollment-toolbar__extra">
            <span class="enrollment-toolbar__extra-label">天波</span>
            <enrollment-tb-residual-toolbar
              :scope-kind="2"
              :school-department-id="activeSchoolId"
              :filter-params="tbFilterParams"
              :only-tb-remaining.sync="onlyTbRemaining"
              @filter-change="loadList(1)"
              @deleted="loadList(1)" />
          </div>
        </div>
      </header>

            <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
            <div class="tbl-scroll-host">
            <el-table height="100%"
        :data="list"
        v-loading="loading"
        border
        stripe
        class="custom-tbl enrollment-table"
        style="width: 100%"
        empty-text="暂无异动学生"
      >
        <el-table-column prop="StuName" label="姓名" min-width="100" />
        <el-table-column prop="StuCode" label="学号" min-width="110" show-overflow-tooltip />
        <el-table-column prop="CardNumber" label="卡号" min-width="120" show-overflow-tooltip />
        <el-table-column prop="SourceDepartmentName" label="离校原班级" min-width="140" show-overflow-tooltip />
        <el-table-column label="异动类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="statusTagType(scope.row.SchoolStatus)" effect="plain">
              {{ scope.row.SchoolStatusName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="StatusChangeReason" label="原因" min-width="140" show-overflow-tooltip />
        <el-table-column prop="StatusChangedAt" label="办理时间" min-width="160" />
        <el-table-column v-if="isDingTalkSchool" label="天波" width="88" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.TbThirdPartId > 0" size="mini" type="warning" effect="plain">已同步</el-tag>
            <span v-else class="tb-empty">—</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" class="op-link" @click="openResume(scope.row)">复学</el-button>
            <el-button type="text" class="op-link" @click="openReason(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
            </div>

      <div class="pager-bar">
        <el-pagination
          layout="total, prev, pager, next"
          :page-size="pageSize"
          :total="total"
          :current-page.sync="page"
          @current-change="loadList"
        />
      </div>
    </section>

    <el-dialog title="复学" :visible.sync="resumeVisible" width="560px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="学生">{{ resumeRow && resumeRow.StuName }}</el-form-item>
        <el-form-item label="目标班级" required>
          <class-cascader-select
            v-model="resumeTargetDeptId"
            :school-id="activeSchoolId"
            placeholder="校区 / 学段 / 年级 / 班级"
          />
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="resumeReason" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="resumeVisible = false">取消</el-button>
        <el-button type="primary" :loading="resumeSaving" @click="submitResume">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改原因" :visible.sync="reasonVisible" width="480px" :close-on-click-modal="false">
      <el-input v-model="reasonText" type="textarea" :rows="3" />
      <div slot="footer">
        <el-button @click="reasonVisible = false">取消</el-button>
        <el-button type="primary" :loading="reasonSaving" @click="submitReason">保存</el-button>
      </div>
    </el-dialog>

    <batch-enrollment-status-dialog
      :visible.sync="batchDialogVisible"
      :school-department-id="activeSchoolId"
      @success="loadList(1)" />
  </section>
</template>

<script>
import {
  getTransferLeavePage,
  resumeEnrollment,
  updateEnrollmentReason
} from '../../api/modules/studentEnrollment';
import ClassCascaderSelect from '../../components/ClassCascaderSelect';
import EnrollmentTbResidualToolbar from '../../components/EnrollmentTbResidualToolbar';
import BatchEnrollmentStatusDialog from '../../components/BatchEnrollmentStatusDialog';
import dingTalkSchoolMixin from '../../mixins/dingTalkSchoolMixin';
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps';

const STATUS_ITEMS = [
  { value: '', label: '全校离校学生档案', tone: 'all' },
  { value: '2', label: '转学离校', tone: 'transfer' },
  { value: '3', label: '退学离校', tone: 'withdraw' },
  { value: '1', label: '休学异动', tone: 'suspend' }
];

export default {
  name: 'TransferLeaveStudent',
  mixins: [dingTalkSchoolMixin],
  components: { ClassCascaderSelect, EnrollmentTbResidualToolbar, BatchEnrollmentStatusDialog },
  data() {
    return {
      statusItems: STATUS_ITEMS,
      statusFilter: '',
      sourceClassName: '',
      keyword: '',
      list: [],
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      resumeVisible: false,
      resumeRow: null,
      resumeTargetDeptId: null,
      resumeReason: '',
      resumeSaving: false,
      reasonVisible: false,
      reasonRow: null,
      reasonText: '',
      reasonSaving: false,
      onlyTbRemaining: false,
      batchDialogVisible: false
    };
  },
  computed: {
    tbFilterParams() {
      const params = {
        SourceClassName: this.sourceClassName,
        Keyword: this.keyword
      };
      if (this.statusFilter !== '') params.Status = Number(this.statusFilter);
      return params;
    },
    viewTitle() {
      const hit = STATUS_ITEMS.find(x => x.value === this.statusFilter);
      return hit ? hit.label : '全校离校学生档案';
    },
    activeSchoolId() {
      return resolveActiveSchoolId(this);
    }
  },
  watch: {
    activeSchoolId: {
      immediate: true,
      async handler() {
        await this.loadCurrentSchoolSchType(this.activeSchoolId);
        if (!this.isDingTalkSchool) this.onlyTbRemaining = false;
        this.loadList(1);
      }
    }
  },
  methods: {
    statusTagType(status) {
      if (Number(status) === 3) return 'danger';
      if (Number(status) === 1) return 'warning';
      return '';
    },
    onStatusSelect(value) {
      this.statusFilter = value;
      this.loadList(1);
    },
    resetQuery() {
      this.sourceClassName = '';
      this.keyword = '';
      this.onlyTbRemaining = false;
      this.loadList(1);
    },
    loadList(page) {
      if (!this.activeSchoolId) {
        this.list = [];
        this.total = 0;
        this.$message.warning('请先在顶部选择学校');
        return;
      }
      if (page) this.page = page;
      this.loading = true;
      const params = {
        schoolDepartmentId: this.activeSchoolId,
        sourceClassName: this.sourceClassName,
        keyword: this.keyword,
        page: this.page,
        intPageSize: this.pageSize
      };
      if (this.statusFilter !== '') params.status = Number(this.statusFilter);
      if (this.onlyTbRemaining) params.onlyTbRemaining = true;
      getTransferLeavePage(params)
        .then(res => {
          this.loading = false;
          if (res.data && res.data.success) {
            const pageModel = res.data.response || {};
            this.list = pageModel.data || [];
            this.total = pageModel.dataCount || 0;
          } else {
            this.$message.error((res.data && res.data.msg) || '加载失败');
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openResume(row) {
      this.resumeRow = row;
      this.resumeTargetDeptId = null;
      this.resumeReason = '复学';
      this.resumeVisible = true;
    },
    submitResume() {
      if (!this.resumeRow || !this.resumeTargetDeptId) {
        this.$message.warning('请选择目标班级');
        return;
      }
      this.resumeSaving = true;
      resumeEnrollment({
        FromSuspend: !!this.resumeRow.IsSuspendOnMain,
        Reason: this.resumeReason,
        Items: [{
          StudentId: this.resumeRow.Id,
          TargetDepartmentId: Number(this.resumeTargetDeptId)
        }]
      }).then(res => {
        this.resumeSaving = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '复学成功');
          this.resumeVisible = false;
          this.loadList();
        } else {
          this.$message.error((res.data && res.data.msg) || '复学失败');
        }
      }).catch(() => {
        this.resumeSaving = false;
      });
    },
    openReason(row) {
      this.reasonRow = row;
      this.reasonText = row.StatusChangeReason || '';
      this.reasonVisible = true;
    },
    submitReason() {
      if (!this.reasonRow) return;
      this.reasonSaving = true;
      updateEnrollmentReason({
        StudentId: this.reasonRow.Id,
        IsSuspendOnMain: !!this.reasonRow.IsSuspendOnMain,
        Reason: this.reasonText
      }).then(res => {
        this.reasonSaving = false;
        if (res.data && res.data.success) {
          this.$message.success('已更新');
          this.reasonVisible = false;
          this.loadList();
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败');
        }
      }).catch(() => {
        this.reasonSaving = false;
      });
    }
  }
};
</script>

<style scoped>
.enrollment-page {
  --enroll-primary: #3b82f6;
  --enroll-ink: #1e293b;
  --enroll-muted: #64748b;
  --enroll-line: #e2e8f0;
}

.filter-card {
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
}

.filter-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 18px 12px;
  font-size: 15px;
  font-weight: 600;
  color: var(--enroll-ink);
  border-bottom: 1px solid var(--enroll-line);
}

.filter-head i {
  color: var(--enroll-primary);
}

.filter-nav {
  padding: 10px 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 0;
  background: transparent;
  border-radius: 8px;
  padding: 11px 12px;
  cursor: pointer;
  color: var(--enroll-ink);
  transition: background-color 0.18s ease, color 0.18s ease;
  text-align: left;
}

.filter-item:hover {
  background: #f1f5f9;
}

.filter-item.is-active {
  background: #eff6ff;
  color: var(--enroll-primary);
  font-weight: 600;
}

/* 子类型相对「全校」项缩进一层。创建于 2026-08-30 */
.filter-item.is-child {
  padding-left: 28px;
}

.filter-item__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #94a3b8;
}

.filter-item__dot.tone-all { background: #3b82f6; }
.filter-item__dot.tone-transfer { background: #f59e0b; }
.filter-item__dot.tone-withdraw { background: #ef4444; }
.filter-item__dot.tone-suspend { background: #8b5cf6; }

.filter-item__label {
  flex: 1;
  font-size: 13px;
  line-height: 1.4;
}

.filter-item__arrow {
  font-size: 12px;
  color: #cbd5e1;
  opacity: 0;
  transition: opacity 0.18s ease;
}

.filter-item.is-active .filter-item__arrow,
.filter-item:hover .filter-item__arrow {
  opacity: 1;
}

.page-toolbar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 0 0 auto;
  margin-bottom: 12px;
}

.enrollment-toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 0 0 auto;
}

.enrollment-toolbar__query {
  margin-bottom: 0;
  flex: 0 0 auto;
  width: 100%;
}

.enrollment-toolbar__extra {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 14px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.enrollment-toolbar__extra-label {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  flex-shrink: 0;
}

.page-toolbar__title h2 {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
  color: var(--enroll-ink);
}

.page-toolbar__title p {
  margin: 0;
  font-size: 12px;
  color: var(--enroll-muted);
}

.op-link {
}

.pager-bar {
  display: flex;
  justify-content: flex-end;
  flex: 0 0 auto;
  margin-top: 12px;
}

.tb-empty {
  color: #cbd5e1;
}

@media (max-width: 960px) {
  .enrollment-page {
    flex-direction: column;
  }
  .filter-card {
    width: 100% !important;
    margin-right: 0 !important;
    margin-bottom: 16px;
  }
  /* 与全站一致：类型筛选保持单列，避免挤成两列。最后修改：2026-08-24 */
  .filter-nav {
    flex-direction: column;
    flex-wrap: nowrap;
  }
  .filter-item {
    width: 100%;
    flex: 0 0 auto;
  }
}
</style>
